import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import { RecoilRoot } from "recoil";
import { CookiesProvider } from "react-cookie";
import MouseTracker from "./components/MouseTracker";
import HelpModeless from "./components/HelpModeless";
import * as swRegistration from "./swRegistration";
import { TutorialProvider } from "./context/TutorialContext";
import { ConfirmProvider } from "./components/confirm/ConfirmProvider";
import ErrorHandler from "./components/ErrorHandler";
import { errorEmitter } from "./utils/errorEmitter";
import { loadWebConfig } from "./services/webConfig";

function readOverlayError(node: HTMLElement) {
  try {
    let text = "";
    if (node.tagName === "IFRAME") {
      const doc = (node as HTMLIFrameElement).contentDocument || (node as HTMLIFrameElement).contentWindow?.document;
      text = doc?.body?.innerText ?? "";
    } else {
      text = node.innerText ?? "";
    }
    text = text.trim();
    if (text) {
      errorEmitter.emit(new Error("[Webpack Overlay / Compile Error]\n\n" + text));
    }
  } catch {}
}

const OVERLAY_IDS = new Set(["webpack-dev-server-client-overlay", "webpack-dev-server-client-overlay-div"]);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of Array.from(mutation.addedNodes)) {
      if (!(node instanceof HTMLElement) || !OVERLAY_IDS.has(node.id)) continue;

      if (node instanceof HTMLIFrameElement) {
        // iframe은 콘텐츠가 채워진 뒤에 읽어야 함
        node.addEventListener("load", () => readOverlayError(node));
        setTimeout(() => readOverlayError(node), 0); // 이미 로드된 경우 대비
      } else {
        readOverlayError(node);
      }
      node.style.display = "none";
    }
  }
});

observer.observe(document.body, { childList: true });

window.addEventListener("unhandledrejection", (event) => {
  console.error("[Unhandled Promise Rejection]", event.reason);
  event.preventDefault();
  errorEmitter.emit(event.reason instanceof Error ? event.reason : new Error(String(event.reason)));
});

window.addEventListener("error", (event) => {
  console.error("[Global Error]", event.error);
  event.preventDefault();
  errorEmitter.emit(event.error instanceof Error ? event.error : new Error(event.message));
});
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

loadWebConfig().then(() =>
  root.render(
    <ErrorHandler>
      <RecoilRoot>
        <MouseTracker>
          <CookiesProvider>
            <ConfirmProvider>
              <TutorialProvider>
                <App />
              </TutorialProvider>
            </ConfirmProvider>
          </CookiesProvider>
        </MouseTracker>
      </RecoilRoot>
    </ErrorHandler>,
  ),
);

// 서비스 워커 등록
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}

// swRegistration.register();
